import isBlank from '../../Utils/Blank';

const ValidPublishers = (value, allValues) => {
  if (isBlank(allValues.internal_only) && isBlank(allValues.publishers)) {
    return 'Publisher required';
  }
  return undefined;
};

export default ValidPublishers;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Helpers/ValidPublishers.tsx